import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Vehicle, vehicleSchema } from '../schemas/vehicle.schema';

/**
 * Updates Vehicles by ID
 * @param vehicles The Vehicles being updated
 * @returns Data Object containing the updated Vehicles
 */
export function putVehiclesUpdateByIds(
  this: unknown,
  vehicles: Partial<Vehicle>[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesUpdateByIdsUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(vehicles),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(vehicleSchema.omit({ modifiedOn: true })),
        message: z.string().nullable(),
      })
    )
  );
}
